<script lang="ts">
  import { snapScrollPosition } from '$lib/actions/snap-scroll-position';
  import { cn } from '$lib/utils';
  import Slider from './slider.svelte';
  import { reducedMotion } from '$lib/stores/reduced-motion';
  import SliderButton from './ui/slider-button.svelte';
  import { t } from '$lib/i18n';
  import Image from './image.svelte';
  import { onMount } from 'svelte';

  export let images: ({ url: string; alt: string } | undefined)[] | undefined = [];
  export let padding: 'md' | 'sm' = 'md';

  let className: string | undefined = undefined;
  export { className as class };

  let carousel: HTMLElement;
  let carouselIdx = 0;

  const handleGallery = (to: 'left' | 'right') => {
    if (to === 'left') {
      carousel.scrollTo({
        left: carousel.clientWidth * (carouselIdx - 1),
        behavior: $reducedMotion ? 'instant' : 'smooth'
      });
    } else if (to === 'right') {
      carousel.scrollTo({
        left: carousel.clientWidth * (carouselIdx + 1),
        behavior: $reducedMotion ? 'instant' : 'smooth'
      });
    }
  };

  // Reset if images change
  $: if (carousel && images) {
    carousel.scrollTo({ left: 0, behavior: 'instant' });
    carouselIdx = 0;
  }

  onMount(() => {
    setTimeout(() => {
      if (carousel && images) {
        carousel.scrollTo({ left: 0, behavior: 'instant' });
        carouselIdx = 0;
      }
    }, 50);
  });
</script>

{#if images}
  <div class={cn('flex', className)}>
    <div class="relative isolate group mx-auto">
      <div
        bind:this={carousel}
        use:snapScrollPosition={(i) => {
          carouselIdx = i;
        }}
        class="flex h-full w-full object-cover snap-x snap-mandatory overflow-x-hidden hide-scrollbar rounded-md"
      >
        {#each images as image}
          <div class="min-w-full select-none snap-center snap-always">
            <Image
              src={image?.url}
              alt={image?.alt}
              class="h-full w-full bg-primary/4 object-cover"
            />
          </div>
        {/each}
      </div>
      {#if images.length > 1}
        <div class="absolute bottom-0 left-0">
          <!-- Slider -->
          <div class="w-full flex justify-between">
            {#if images?.length}
              <Slider
                total={images.length}
                currentIndex={carouselIdx}
                class={cn('m-2.5 lg:m-4', padding === 'sm' && 'lg:m-2.5')}
              />
            {/if}
          </div>
        </div>
      {/if}
      {#if images.length > 1}
        <!-- Slider Buttons-->
        <div class={cn('absolute left-2.5 top-1/2 -translate-y-1/2 lg:left-4 z-10')}>
          <SliderButton
            aria-label={$t('a11y.image-previous')}
            icon="chevron-left"
            disabled={carouselIdx === 0}
            class="pointer-events-none !opacity-0 focus-visible:!opacity-100 group-hover:pointer-events-auto group-hover:!opacity-100 z-20"
            on:click={(e) => {
              e.preventDefault();
              handleGallery('left');
            }}
          />
        </div>
        <div class={cn('absolute right-2.5 top-1/2 -translate-y-1/2 lg:right-4')}>
          <SliderButton
            aria-label={$t('a11y.image-next')}
            icon="chevron-right"
            disabled={carouselIdx >= images.length - 1}
            class="pointer-events-none !opacity-0 focus-visible:!opacity-100 group-hover:pointer-events-auto group-hover:!opacity-100 z-20"
            on:click={(e) => {
              e.preventDefault();
              handleGallery('right');
            }}
          />
        </div>
        <!-- END Slider Buttons -->
      {/if}
    </div>
  </div>
{/if}
